import { inject, Injectable } from '@angular/core';
import { INotification } from './notification-factory.service';
import { PushNotificationService } from './push-notification.service';
import { MessageTemplate } from '../../models/enums/enums';
import { AdditionalInformationService } from '../additional-information/additional-information.service';

@Injectable({
  providedIn: 'root'
})
export class TaskAssignedNotificationService implements INotification {
  constructor(
    private pushNotificationService: PushNotificationService,
    private additionalInfoService: AdditionalInformationService
  ) { }

  notify(message:string,data: { [key: string]: any }): void {
    this.pushNotificationService.pushNotification(message,MessageTemplate.TaskAssigned, data);
    this.additionalInfoService.additonalInfoRequest$.next(data['additionalInformation']);
  }
}
